import cloneDeep from 'lodash/fp/cloneDeep'
import {
  VALIDATE_FINDANIFA,
  FINDANIFA_CLEAR_VALIDATION_STATE
} from './findAnIndependantFinancialAdviserActions'
import searchCriteriaReducer from './searchCriteriaReducer'
import {
  SERVICE_SELECTED,
  INVESTOR_DESCRIPTION_SELECTED,
  KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED,
  MONTHLY_INVESTMENT_AMOUNT_SELECTED,
  ONCE_OFF_INVESTMENT_AMOUNT_SELECTED,
  PREFERRED_LANGUAGE_SELECTED,
  SEARCH_CRITERIA_CLEAR_ALL,
  SEARCH_CRITERIA_SET_USER_ADDRESS,
  actions
} from './searchCriteriaActions'

const initialState = {
  searchCriteria: searchCriteriaReducer(undefined, {}),
  mandatorySearchCriteriaCompleted: false,
  isInvalid: {
    formIsValid: false,
    investorDescriptionContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    investmentAmountContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    financialServicesContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    preferredLanguagesContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    userLocationContainer: {
      isInvalid: false,
      message: null,
      valid: false
    }
  }
}

export default function (state = initialState, action) {
  var oldState = state
  var newState = cloneDeep(oldState)
  newState.searchCriteria = cloneDeep(oldState.searchCriteria)
  switch (action.type) {
    case SERVICE_SELECTED:
    case INVESTOR_DESCRIPTION_SELECTED:
    case KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED:
    case MONTHLY_INVESTMENT_AMOUNT_SELECTED:
    case ONCE_OFF_INVESTMENT_AMOUNT_SELECTED:
    case PREFERRED_LANGUAGE_SELECTED:
    case SEARCH_CRITERIA_CLEAR_ALL:
    case SEARCH_CRITERIA_SET_USER_ADDRESS:
    case actions.fetched.profileMatches:
    case actions.fetching.profileMatches:
    case actions.set.resultsRefreshed:
      var newSearchCriteria = searchCriteriaReducer(newState.searchCriteria, action)
      newState.searchCriteria = newSearchCriteria
      if (action.dontValid) {
        return newState
      }
      return validateFindAnIfa(newState)
    case VALIDATE_FINDANIFA: {
      return validateFindAnIfa(newState, action.specificComponent)
    }
    case FINDANIFA_CLEAR_VALIDATION_STATE:
      newState.isInvalid = cloneDeep(initialState.isInvalid)
      return newState
  }
  return newState
}

function mandatorySearchCriteriaMet (searchCriteria) {
  return searchCriteria !== null &&
    searchCriteria.financialServices.length > 0 &&
    searchCriteria.investorDescriptionId !== null &&
    searchCriteria.selectedKnowsHowMuchToInvestOptionId !== null &&
    (searchCriteria.userAddress && searchCriteria.userAddress.length > 0)
}

function validateFindAnIfa (newState, toValidate) {
  switch (toValidate) {
    case 'InvestorDescription':
      validateInvestorDescription(newState)
      break
    case 'financialServices':
      validateFinancialServices(newState)
      break
    default:
      validateAll(newState)
      break
  }
  newState.isInvalid.formIsValid = formIsValid(newState)
  newState.mandatorySearchCriteriaCompleted = mandatorySearchCriteriaMet(newState.searchCriteria)
  return newState
}

function formIsValid (state) {
  return state.isInvalid.investorDescriptionContainer.valid &&
    state.isInvalid.financialServicesContainer.valid
}

function validateAll (state) {
  validateInvestorDescription(state)
  validateFinancialServices(state)
  validateInvestmentAmounts(state)
  validateUserLocation(state)
}

function validateInvestorDescription (state) {
  if (state.searchCriteria.investorDescriptionId === null) {
    state.isInvalid.investorDescriptionContainer.isInvalid = 'error'
    state.isInvalid.investorDescriptionContainer.help = 'Please select a description'
    state.isInvalid.investorDescriptionContainer.valid = false
  } else {
    state.isInvalid.investorDescriptionContainer.isInvalid = null
    state.isInvalid.investorDescriptionContainer.help = null
    state.isInvalid.investorDescriptionContainer.valid = true
  }
}

function validateFinancialServices (state) {
  if (state.searchCriteria.financialServices.length < 1) {
    state.isInvalid.financialServicesContainer.isInvalid = 'error'
    state.isInvalid.financialServicesContainer.help = 'Please select at least one service'
    state.isInvalid.financialServicesContainer.valid = false
  } else {
    state.isInvalid.financialServicesContainer.isInvalid = null
    state.isInvalid.financialServicesContainer.help = null
    state.isInvalid.financialServicesContainer.valid = true
  }
}

function validateInvestmentAmounts (state) {
  if (!state.searchCriteria.selectedKnowsHowMuchToInvestOptionId) {
    state.isInvalid.investmentAmountContainer.isInvalid = 'error'
    state.isInvalid.investmentAmountContainer.help = 'Please choose an option'
    state.isInvalid.investmentAmountContainer.valid = false
  } else if (state.searchCriteria.selectedKnowsHowMuchToInvestOptionId === 1 && (!state.searchCriteria.investmentAmounts.onceOffAmount && !state.searchCriteria.investmentAmounts.monthlyAmount)) {
    state.isInvalid.investmentAmountContainer.isInvalid = 'error'
    state.isInvalid.investmentAmountContainer.help = 'Please enter either a monthly amount or a lump sum'
    state.isInvalid.investmentAmountContainer.valid = false
  } else {
    state.isInvalid.investmentAmountContainer.isInvalid = null
    state.isInvalid.investmentAmountContainer.help = null
    state.isInvalid.investmentAmountContainer.valid = true
  }
}

function validateUserLocation (state) {
  if (!state.searchCriteria.userAddress) {
    state.isInvalid.userLocationContainer.isInvalid = 'error'
    state.isInvalid.userLocationContainer.help = 'Please enter an address'
    state.isInvalid.userLocationContainer.valid = false
  } else {
    state.isInvalid.userLocationContainer.isInvalid = null
    state.isInvalid.userLocationContainer.help = null
    state.isInvalid.userLocationContainer.valid = true
  }
}
